import React, { Component } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import InputAdornment from "@mui/material/InputAdornment";
import SimpleReactValidator from "simple-react-validator";
import { LimitService } from "../../../service/settings/manage/limit.service.js";
import { Spinner } from "react-bootstrap";
import {
  sweetErrorAlert,
  sweetStatusAlert,
  sweetSuccessAlert
} from "../../../components/common/SweetAlert";
import ContentWrapper from "../../../components/common/ContentWrapper";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

class ManageLimit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTableDataLoading: false,
      isLoading: false,
      addLimitModal: false,
      updateLimitModal: false,
      limit: null,
      updateLimit: null,
      selectedLimit: null,
      limits: [],
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    this.getAllLimit();
  }

  getAllLimit = () => {
    this.setState({ isTableDataLoading: true });
    LimitService.getLimits().then((response) => {
      if (response.success) {
        this.setState({ limits: response.data, isTableDataLoading: false });
      } else {
        this.setState({ isTableDataLoading: false });
      }
    });
  };

  toggleUpdateLimitModal = (limit) => {
    const { updateLimitModal } = this.state;
    this.validator.purgeFields();
    this.validator.hideMessages();
    if (!updateLimitModal) {
      this.setState({
        updateLimit: limit.limit,
        selectedLimit: limit.limit_id,
        updateLimitModal: true,
      });
    } else {
      this.setState({
        updateLimit: null,
        selectedLimit: null,
        updateLimitModal: false,
      });
    }
  };

  handleEditSubmit = () => {
    const { updateLimit, selectedLimit } = this.state;
    if (!this.validator.fieldValid("updateLimit")) {
      this.validator.showMessageFor("updateLimit");
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });
      const newUpdateLimit = {
        limit: updateLimit,
      };
      LimitService.updateLimit(newUpdateLimit, selectedLimit)
        .then((response) => {
          if (response.success) {
            sweetSuccessAlert(
              "Success",
              "Limit updated successfully",
              "success"
            );
            this.setState({ isLoading: false });
            this.setState({ updateLimitModal: false });
            this.getAllLimit();
          } else {
            this.setState({ isLoading: false });
            sweetStatusAlert("Oops", response.message, "info");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetErrorAlert("Error", "Error while updating Limit", "error");
        });
    }
  };

  handleLimitChange = (e) => {
    const { name, value } = e.target;
    this.setState(() => ({ [name]: value }));
  };

  toggleAddLimitModal = () => {
    const { addLimitModal } = this.state;
    this.validator.purgeFields();
    this.validator.hideMessageFor("limit");
    this.setState({
      addLimitModal: !addLimitModal,
      grade: "",
    });
  };

  handleSubmit = () => {
    const { limit } = this.state;
    if (!this.validator.fieldValid("limit")) {
      this.validator.showMessageFor("limit");
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });
      const newLimit = {
        limit: limit,
      };
      LimitService.addLimit(newLimit)
        .then((response) => {
          if (response.success) {
            this.setState({ isLoading: false });
            this.toggleAddLimitModal();
            sweetSuccessAlert(
              "Success",
              "A new student Limit added successfully",
              "success"
            );
            this.getAllLimit();
          } else {
            this.setState({ isLoading: false });
            sweetStatusAlert("Info", response.message, "info");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetErrorAlert("Error", "Error while adding Limit", "error");
        });
    }
  };

  render() {
    const {
      addLimitModal,
      limit,
      updateLimitModal,
      isTableDataLoading,
      isLoading,
      limits,
      updateLimit,
    } = this.state;

    return (
      <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
          <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Manage Registration Limit</h3>
          </div>
          <Button
            className="insert-btn"
            variant="primary"
            onClick={this.toggleAddLimitModal}
            style={{ display: limits.length < 1 ? "block" : "none" }}
          >
            Add New Limit
          </Button>
        </div>
        {isTableDataLoading ? (
          <div
            className="loading-container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "75vw",
              height: "90vh",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div style={{ width: "75vw", height: "90vh", overflow: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="thead">
                    Set a maximum student registration limit
                  </TableCell>
                  <TableCell className="thead" align="right">
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {limits.length > 0 ? (
                  limits.map((Limit) => (
                    <TableRow key={Limit.limit_id}>
                      <TableCell className="tData">{Limit.limit}</TableCell>
                      <TableCell className="tData" align="right">
                        <Button
                          onClick={() => this.toggleUpdateLimitModal(Limit)}
                          className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                          title="Edit Details"
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2}>No limits found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        )}
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={updateLimitModal}
          onHide={this.toggleUpdateLimitModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Limit</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {isLoading ? (
              <div className="loading-container" style={{ height: "50px" }}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Please wait...</span>
                </Spinner>
              </div>
            ) : (
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                  >
                    <TextField
                      id="outlined-start-adornment"
                      sx={{ width: "25ch" }}
                      type="number"
                      name="updateLimit"
                      value={updateLimit ? updateLimit : ""}
                      onChange={this.handleLimitChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            Limit
                          </InputAdornment>
                        ),
                      }}
                    />
                    {this.validator.message(
                      "updateLimit",
                      updateLimit,
                      "required|min:1,num",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Form.Group>
                </Row>
              </Form>
            )}
            <Modal.Footer>
              <Button
                className="modal-btn"
                id="modal-close-button"
                style={closeBtnStyle}
                sx={{ mr: "20px" }}
                onClick={this.toggleUpdateLimitModal}
              >
                Close
              </Button>
              <Button
                className="modal-btn"
                variant="primary"
                style={addBtnStyle}
                onClick={() => this.handleEditSubmit()}
              >
                Save
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={addLimitModal}
          onHide={this.toggleAddLimitModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Create New Limit</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {isLoading ? (
              <div className="loading-container" style={{ height: "50px" }}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Please wait...</span>
                </Spinner>
              </div>
            ) : (
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="exampleForm.ControlInput1"
                  >
                    <TextField
                      id="outlined-start-adornment"
                      sx={{ width: "25ch" }}
                      type="number"
                      name="limit"
                      defaultValue={limit}
                      onChange={this.handleLimitChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            Limit
                          </InputAdornment>
                        ),
                      }}
                    />
                    {this.validator.message(
                      "limit",
                      limit,
                      "required|min:1,num",
                      {
                        className: "text-danger",
                      }
                    )}
                  </Form.Group>
                </Row>
              </Form>
            )}

            <Modal.Footer>
              <Button
                sx={{ mr: "20px" }}
                onClick={this.toggleAddLimitModal}
                className="modal-btn"
                id="modal-close-button"
                style={closeBtnStyle}
              >
                Close
              </Button>
              <Button
                className="modal-btn"
                variant="primary"
                style={addBtnStyle}
                onClick={this.handleSubmit}
              >
                Save
              </Button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      </ContentWrapper>
    );
  }
}

export default ManageLimit;
